/** Companion to OTK/chat-be `NOTIFICATIONS_MODULE`. Default off = legacy chat-be list/socket. When true: OTK HTTP + inbox SSE. */
export const isNotificationsModuleEnabled = (): boolean => String(process.env.REACT_APP_NOTIFICATIONS_MODULE || '').toLowerCase() === 'true'
